"use client";

import React from "react";
import CategoryFilter from "./CategoryFilter";

import PriceRangeFilter from "./PriceRangeFilter";
import { Category } from "@/packages/types/category";
import { usePathname, useSearchParams } from "next/navigation";
import { useFastRouter } from "@/packages/hooks/useFastRouter";

import { SidebarSkeleton } from "@/components/common/Skeletons";

interface Props {
  category: Category | undefined;

  minPrice: string;
  maxPrice: string;
}

const Sidebar: React.FC<Props> = ({
  category,

  minPrice,
  maxPrice,
}) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { fastPush } = useFastRouter();

  if (!category) {
    return <SidebarSkeleton />;
  }

  const hasFilters = Boolean(
    searchParams.get("startPrice") ||
      searchParams.get("endPrice") ||
      searchParams.get("categories") ||
      searchParams.get("skills")
  );

  const clearFilters = () => {
    // Navigate to the current pathname without any query params.
    // This preserves the route slug while removing all filter query params.
    fastPush(pathname);
  };
  return (
    <aside className="w-full space-y-6 p-4 bg-white sticky top-0 min-h-[200px] overflow-y-auto">
      {hasFilters && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={clearFilters}
            className="text-sm px-4 py-2 rounded-md border border-gray-300 text-gray-700  cursor-pointer
               hover:bg-gray-100 hover:text-gray-900 transition"
          >
            Clear Filters
          </button>
        </div>
      )}
      <CategoryFilter category={category} />
      {/* <AgeFilter />
      <SkillsFilter /> */}
      <PriceRangeFilter minPrice={minPrice} maxPrice={maxPrice} />
    </aside>
  );
};

export default Sidebar;
